import style from './index.style';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useMemo } from 'react';
import { getBrands } from 'actions/product';
import useTranslation, { mergeTranslation } from '../../hooks/useTranslation';
import {
  getLocaleTranslation,
  setLocale,
  setTranslation,
} from 'actions/translations';
import { setLocalStorage } from '../../tools/localStorage';
import { useRouterWithLang } from 'hooks/useRouterWithLang';

function Brands({ publicBrands }) {
  const user = useSelector((state) => state?.user);
  const brands = useSelector((state) => state?.brands).filter(
    (brand) =>
      !brand.restrictions.length ||
      (user.countryCode && !brand.restrictions.includes(user.countryCode)) ||
      user.ignoreRestrinctions
  );
  const PERMISSIONS = useSelector((state) => state.permissions);
  const catalogs = useSelector((state) => state?.user?.userCatalogs);
  const router = useRouterWithLang();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((s) => s.isLoggedIn);
  const { TRANSLATIONS } = useTranslation();
  const { lang } = router.query;

  useEffect(() => {
    let timeoutRef;
    timeoutRef = setTimeout(() => {
      if (lang) {
        dispatch(
          getLocaleTranslation(lang, (translations) => {
            dispatch(setTranslation(mergeTranslation(translations || {})));
            dispatch(setLocale(lang));
            setLocalStorage(`cachedLocale`, lang);
          })
        );
      }
    }, 500);

    return () => clearTimeout(timeoutRef);
  }, [dispatch, lang]);

  useEffect(() => {
    dispatch(getBrands());
  }, [dispatch, publicBrands]);

  const filteredBrands = useMemo(() => {
    const orderedBrands = brands.sort((a, b) =>
      a.name.localeCompare(b.name, 'en', { sensitivity: 'base' })
    );

    return orderedBrands.reduce((r, e) => {
      let letter = e.name[0];
      if (!r[letter]) r[letter] = { letter, brands: [e.name] };
      else r[letter].brands.push(e.name);
      return r;
    }, {});
  }, [brands]);

  const goToCatalog = useCallback(
    (brand) => {
      const query = `brand=${brand}`;
      return PERMISSIONS.IS_PRIVATE
        ? router.push(`/channel/${catalogs?.[0]?._id}/edit/products?${query}`)
        : router.push(`/product?${query}`);
    },
    [PERMISSIONS.IS_PRIVATE, catalogs, router]
  );

  if (filteredBrands) {
    return (
      <>
        <div>
          <div className="brands__container row">
            {Object.keys(filteredBrands).map((letter) => (
              <div key={letter} className={'col-md-3'}>
                <div className={'letter'}>{letter}</div>
                {filteredBrands?.[letter]?.brands?.map((brand) => (
                  <div
                    onClick={() => goToCatalog(brand)}
                    key={brand}
                    className={'brands-list'}
                  >
                    {brand}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        <style jsx>{style}</style>
      </>
    );
  } else {
    return null;
  }
}

export default Brands;
